import {
  ProjectExperiments,
  SessionExperiments,
  UserExperiments,
} from '../experiments';

export const sessionExperiments: Partial<SessionExperiments> = {
  'T240666-webapp-home-page-redesign-v8': 'control',
};

export const userExperiments: Partial<UserExperiments> = {
  'T240661-relevant-reviews-by-skills': 'test',
  'T238214-search-users-highlight-keywords': 'test',
  'T236745-project-contest-webapp-search': 'test',
  'T111865-logged-in-pjp-live-chat-just-enrollment': 'control',
  'T58186-giveget-delayed-payment-verify-v2': 'control',
  'T90189-image-thumbnail-service': 'control',
  'T178308-freelancer-my-projects-empty-state-V2': 'control',
  'T194666-hourly-initial-payment': 'control',
  'T221621-fixed-initial-payment-v3': 'control',
  'T198705-memberships-page-webapp-migration-v4': 'test',
  'T237267-pjp-swap-hourly-and-fixed-project-positions': 'control',
  'TNS-T242401-require-payment-verification-first-hireme-duplicate-ip': 'test',
  'TNS-T198333-show-kyc-onboarding-video': 'control',
  'T228455-waiting-screen': 'control',
  webapp_playground_test: 'control',
};
export const projectExperiments: Partial<ProjectExperiments> = {};

export const isWhitelistUser = false;

export const shouldEnrol = true;
